import { Validator } from "../Validator"
import TimeInput from "../Helpers/TimeInput.svelte"

export class TimeValidator extends Validator {
    public readonly inputmode = "time"
    public readonly inputHelper = TimeInput
    public readonly hideInputField = true

    constructor() {
        super("time", "A time picker")
    }
}
